const constants = Object.freeze({
  visibility: {
    Visible: 1,
    Hidden: 2,
    HIDDEN_WHEN_NOT_IN_SALE: 3,
    CUSTOM_SCHEDULE: 4,
  },
  sales_channel: {
    Online: 1,
    Offline: 2,
  },
  price_type: {
    Free: 1,
    Paid: 2,
  },
  delivery_method: {
    'E-Ticket': 1,
    'Will-Call': 2,
  },
})

export default constants
